import { FC } from "react";
import clsx from "clsx";
import Anchor from "../../ui/anchor";

import Icon from "@ht/shared/fonts/deos-pis/logo-arsi";

interface IProps {
    className?: string;
    inverted?: boolean;
}

const Logo: FC<IProps> = ({ className, inverted = false }) => {

    return (
        <div className={clsx("flex flex-row items-center h-[20px]", className)} style={{ width: "60px" }}>
            <Icon className={clsx("w-[24px] h-[24px] mr-1", !inverted && "text-white", inverted && "text-primary")} ></Icon>
            <h1 className={clsx(
                "logo mb-0 text-lg leading-5",

            )}
            >
                <Anchor path="/" className={clsx(!inverted && "text-white", inverted && "text-black", "font-semibold")}>
                    arsi.<span></span>
                </Anchor>
            </h1>
        </div>
    );
};

export default Logo;
